import styled from "styled-components";

let titleBarHeight = 100;
let paginationHeight = 40;


export const OverviewBigScreenWrapper = styled.div`
    width: 100%;
    height: 100%;
    color: #FFFFFF;
    letter-spacing: 2px;
    background-color: rgba(2, 32, 44, 0.815);
`;


export const OverviewBigScreenInnerWrapper = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    color: #FFFFFF;
    letter-spacing: 2px;
    display: flex;
`;

export const ScreenBorderTop = styled.img`
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    z-index: 100;
    height: ${titleBarHeight}px;              
    object-fit: fill;          
`;
export const ScreenBorderBottom = styled.img`
    position: absolute;
    left: -10%;
    bottom: 0px;
    width: 120%;
    height: 70px;
    z-index: 50;
`;

export const ScreenTitleBar = styled.div`
    position: absolute;
    z-index: 110;
    left: 0%;
    top: 0%;
    width: 100%;
    height: ${titleBarHeight-10}px;
    padding: 5px 20px 0px 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-around;
`;

export const OverviewBigScreenContent = styled.div`
    display: grid;
    position: absolute;
    top: calc(${titleBarHeight}px);
    bottom: calc(${paginationHeight}px);
    width: 100%;
    height: calc(100% - ${titleBarHeight}px - ${paginationHeight}px);
    padding: 40px 70px;
    overflow-x: hidden;
    overflow-y: hidden;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: 1fr 1fr 1fr;
    grid-gap: 40px;
    align-items: stretch;
    justify-items: stretch;
    box-sizing: border-box;
`;

export const DeviceCardWrapper = styled.div`
  background-image: url(/static/images/big-screen/qyc/device-card-border.png);
  background-size: 100% 100%; 
  background-repeat: no-repeat;
  padding: 14px 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  height: 100%;
  object-fit: fill;          
`;



export const CardHeader = styled.div`
  background-image: url(/static/images/big-screen/qyc/device-card-title-background.png);
  background-size: 100% 85%; 
  background-repeat: no-repeat;
  border-top-left-radius: 18px;
  border-top-right-radius: 18px;
  overflow: hidden;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  //border-bottom: 1px solid #f0f0f0;
`;

export const Name = styled.div`
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  align-items: center;
  justify-content: center;
  color: #fafafa;
  line-height: 1.4;
`;

export const InfoLabel = styled.div`
  font-size: 14px;
  color: #f7f1f1;
  font-weight: 400;
  line-height: 1.4;
  padding-left: 10px;
`;

export const InfoValue = styled.div`
  font-size: 14px;
  color: #eeeaea;
  font-weight: 500;
  line-height: 1.4;
  margin-bottom: 4px;
  
  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const LastLine =  styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
`;

export const ViewDetailButton = styled.div`
  display: flex;
  align-items: center;
  padding-right: 5px;
  font-size: 16px;
  color: #1a4474;
  border-bottom: 1px dashed #0f3363;
  line-height: 1.2; 
  padding-bottom: 2px; 
  white-space: nowrap; 
  margin-left: auto;
`;

export const PaginationWrapper = styled.div`
  background-image: url(/static/images/big-screen/qyc/screen-border-bottom.png);
  background-size: 100% 100%;  /* 或 cover */
  background-repeat: no-repeat;
  
  position: absolute;
  bottom: 0;     
  display: flex;
  justify-content: center;
  height: ${paginationHeight}px;
  width: 100%;
  z-index: 100;

  .ant-pagination {
        background: transparent;  
        color: #FFFFFF;
        padding-top: 5px;

            // 上一页/下一页按钮
        .ant-pagination-prev,
        .ant-pagination-next {
            min-width: 28px;
            height: 28px;
            line-height: 26px;
            border-radius: 4px;
            background: transparent;
            border: 1px solid rgba(255, 255, 255, 0.3);
            color: #FFFFFF;
            transition: all 0.2s;

            &:hover:not(.ant-pagination-disabled) {
                border-color: #1890ff;
                background: rgba(24, 144, 255, 0.2);
            }

            // 禁用状态（只有一页时）
            &.ant-pagination-disabled {
                border-color: rgba(255, 255, 255, 0.1);
                color: rgba(255, 255, 255, 0.3);
                cursor: not-allowed;
                .ant-pagination-item-link {
                color: rgba(255, 255, 255, 0.3);
                }
            }

            .ant-pagination-item-link {
                color: #FFFFFF;
                font-size: 12px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }

         .ant-pagination-item-active {
            border-color: rgba(255, 255, 255, 0.1);
            background: rgba(255, 255, 255, 0.1);  
            a {
                color: #fff;
            }
        }
  }
`;

export const CardContent = styled.div`
    flex: 1 1 auto;
    display: grid;
    grid-template-columns: 1fr 1fr ;
    grid-gap: 20px;
    margin: 10px;
    padding-bottom: 10px;
`;

export const StatusBox = styled.div`
  flex: 1;                    
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.05);
  display: flex;
  flex-direction: column;      
  align-items: center;
  justify-content: center;
  padding: 6px 4px;
  color: #FFFFFF;
  font-size: 12px;
`;


export const AlarmBox = styled.div`
  flex: 1;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.05);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 6px 4px;
  color: #FFFFFF;
  font-size: 12px;
`;

export const StatusText = styled.div`
    font-weight: 500;
    letter-spacing: 1px;
    font-size: 18px;
    padding-top: 5px;
`;

export const Icon = styled.div`
   font-size: 18px;
   margin-bottom: 4px;
 `;